import { BonusTitleContentStyled, BonusTitleDescriptionStyled, BonusTitleStyled } from "../styled/BonusTitleStyled.js";
import { useBonusContext } from "../bonusContext.js";
import { BonusCard } from "./BonusCard/BonusCard.jsx";
import { BonusTime } from "./BonusTime.jsx";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const BonusTitle = ({onClick, style}) => {
    const {getLangPath} = useLangContext();
    const {bonusAvailablePercent, bonusAvailableSecondsLeft} = useBonusContext();
    return (!!bonusAvailablePercent &&
            <BonusTitleStyled style={style} onClick={onClick}>
                <BonusTitleContentStyled>
                    <BonusCard>
                        +{bonusAvailablePercent}%
                    </BonusCard>
                    <BonusTitleDescriptionStyled>
                        {getLangPath('bonus.welcome.first_deposit_bonus')}
                    </BonusTitleDescriptionStyled>
                    {!!bonusAvailableSecondsLeft && <BonusTime seconds={bonusAvailableSecondsLeft}/>}
                </BonusTitleContentStyled>
            </BonusTitleStyled>
    )
}